<template lang="html">
  <div class="container" id="text-page">
    
    <h1 class="mb-3 page-title">Términos y Condiciones de uso</h1>
    
    <div class="content" v-html="row"></div>
    
    <!-- <div class="content">
      <p>
        El presente documento establece los términos y condiciones bajo los cuales se permite el uso de la plataforma digital www.bazaarflex.com.com.mx, propiedad de Bazaar Flex S.A. DE C.V., con domicilio en Sienita 2074, Colonia Mariano Otero, Zapopan, Jalisco, México, C.P. 45067.
      </p>

      <br />
      <h5>1. NATURALEZA DEL SERVICIO</h5>
      <p>
        Bazaar Flex es una plataforma digital que funge exclusivamente como intermediario comercial entre productores mexicanos y compradores internacionales. No es propietario, fabricante ni distribuidor directo de los productos ofrecidos. El productor es el único responsable de la calidad, seguridad, legalidad y garantía de los productos.
      </p>

      <br />
      <h5>2. USO DE LA PLATAFORMA</h5>
      <p>
        El usuario se compromete a utilizar la plataforma de forma lícita. Debe proporcionar información verídica y mantener la confidencialidad de sus credenciales. Bazaar Flex puede suspender cuentas por uso indebido, fraude o incumplimiento de estos términos.
      </p>

      <br />
      <h5>3. PROCESO DE COMPRA</h5>
      <p>
        Las compras se realizan a través de la plataforma, con medios de pago electrónicos. Los precios están expresados en diferentes monedas, pero la liquidación final dependerá del método de pago y tasa de cambio.
      </p>

      <br />
      <h5>4. ENVÍOS Y ADUANAS</h5>
      <p>
        El envío de productos es realizado por terceros. El tiempo de entrega es estimado. El comprador es responsable de aranceles, impuestos y trámites aduaneros en su país.
      </p>

      <br />
      <h5>5. GARANTÍAS Y RESPONSABILIDADES</h5>
      <p>
        Bazaar Flex se deslinda de cualquier responsabilidad relacionada con la calidad, funcionamiento, legalidad o garantía del producto. Estas son responsabilidad del productor. En caso de disputa, Bazaar Flex podrá mediar, pero no garantiza resoluciones a favor de alguna de las partes.
      </p>

      <br />
      <h5>6. TRADUCCIONES</h5>
      <p>
        El contenido del sitio puede mostrarse en varios idiomas mediante traducciones automáticas. En caso de discrepancias, la versión en español prevalece.
      </p>

      <br />
      <h5>7. PROPIEDAD INTELECTUAL</h5>
      <p>
        Todos los contenidos del sitio están protegidos por derechos de autor y marcas registradas. Está prohibido su uso sin autorización previa.
      </p>

      <br />
      <h5>8. JURISDICCIÓN Y LEGISLACIÓN APLICABLE</h5>
      <p>
        Este documento se rige por las leyes de los Estados Unidos Mexicanos. Las partes se someten a los tribunales de Zapopan, Jalisco.
      </p>

      <br />
      <h5>9. CONTACTO</h5>
      <p>
        Cualquier duda o aclaración puede dirigirse a contacto@bazaarflex.com.com.mx.
      </p>

      <br />
      <h5>10. PRODUCTOS PROHIBIDOS</h5>
      <p>
        Está estrictamente prohibida la compra y comercialización dentro de la plataforma de los siguientes productos:
      </p>
      <ul>
        <li>Armas de fuego, municiones o explosivos.</li>
        <li>Cualquier tipo de material pornográfico.</li>
        <li>Drogas, sustancias ilegales o precursores químicos.</li>
        <li>Productos que inciten al odio, discriminación o violencia.</li>
        <li>Seres vivos, incluyendo animales, insectos o plantas no permitidas por la ley.</li>
      </ul>

      <p>
        La inclusión de este tipo de productos podrá derivar en la cancelación inmediata de la cuenta, bloqueo de fondos y, en su caso, la notificación a las autoridades correspondientes.
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      row:null,
    }
  },

  methods: {
    getData: function(){
      axios.get(tools.url('/api/terminos')).then((response)=>{
        this.row = response.data.body;
      }).catch((error)=>{
      })
    },
  },

  mounted(){
      this.getData();
  },
}
</script>
